import React, {Component} from 'react';

class SearchBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: null,
            countryCode: [],
            defaultCountry: null
        };
        this.changeSearch = this.changeSearch.bind(this);
        this.search = this.search.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
    }
    componentWillMount() {
        var countries = [];
        var defaultCountryCode = "sv-SE";
        this.props.countries.map((c) => {
            if(c.CurrentLanguage === true) {
                this.setState({
                    defaultCountry: c
                })
            }else{
                countries.push(c);
            }
        })
        this.setState({
            countryCode: countries
        })
    }
    changeSearch(event) {
        event.preventDefault();
        this.setState({
            search: event.target.value
        })
    }
    search(event) {
        event.preventDefault();
        var target = window.location.origin + "/" + this.state.defaultCountry.CountryCode + "/search/" + this.state.search;
        window.open(target, "_parent");
    }
    _handleKeyPress(event) {
        if (event.key === "Enter") {
            var target = window.location.origin + "/" + this.state.defaultCountry.CountryCode + "/search/" + this.state.search;
            window.open(target, "_parent");
        }
    }
    render() {
        return (
            <div className="search">
                {this.props.is404 ? (
                    <div>
                        <input onKeyPress={this._handleKeyPress} onChange={this.changeSearch} placeholder={this.props.placeholeder} type="text" className="search-input searchText"/>
                        <button onClick={this.search} type="submit" className="search-button is404 button">{this.props.searchButtonText}</button>
                    </div>
                ) : (
                    <div>
                        <input onKeyPress={this._handleKeyPress} onChange={this.changeSearch}  type="text" className="search-input"/>
                        <button onClick={this.search} type="submit" className="search-button"></button>
                    </div>
                )}
            </div>
        );
    }
}
export default SearchBox;